"use strict";

define('app/template/preview/template.preview.controller',['app/template/edit/template.edit.controller'], function (TemplateEditController) {
  var TemplatePreviewController = TemplateEditController.extend({
    contentName: 'document-edit-content',
    footer: false,
    getDocumentTitle: function getDocumentTitle() {
      var formDesignerController = this.getFormDesignerController();
      if (formDesignerController) {
        return 'Template Preview - ' + formDesignerController.getTemplateModel().title;
      }
    }
  }, {
    requiredPermissions: ['EFORMS_VIEW_TEMPLATE']
  });
  return TemplatePreviewController;
});

